import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import ProcessRunLocationsField from 'components/core/fields/ProcessRunLocationsField';
import ProcessDataLocationsField from 'components/core/fields/ProcessDataLocationsField';
import ProcessService from 'services/ProcessService';

const field = css`
    margin-bottom: 30px;
    .infobox .form-label {
        width: 140px;
    }
`;

const runLocationsField = css`
    ${field}
    .editable-wrapper {
        min-width: 565px !important; // override the editable value for this form
    }
    .Select-control {
        width: 565px;
    }
`;

class DataExplorerParametersForm extends React.Component {
    static propTypes = {
        processId: PropTypes.string,
        process: PropTypes.object,
        processErrors: PropTypes.object, // the process validation errors
        siteFacilities: PropTypes.array,
        showTransformationMessage: PropTypes.bool
    };

    render() {
        return (
            <Flexbox flexDirection="column">
                <ProcessDataLocationsField
                    className={field}
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions
                    siteFacilities={this.props.siteFacilities}
                    forceFormDisplay
                />
                <ProcessRunLocationsField
                    className={runLocationsField}
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions
                    siteFacilities={this.props.siteFacilities}
                    forceFormDisplay
                />
            </Flexbox>
        );
    }
}

// Connect to store so that we can get changes when RIE components are modified, even when rendered inside a modal dialog
const mapStateToProps = (storeState, ownProps) => {
    const processId = ownProps.processId;

    const processState = ProcessService.getMyState(storeState);
    const process = processState.workingCopiesById[processId];
    const processErrors = processState.processErrorsById[processId];
 
    return {
        process,
        processErrors
    };
};


export default connect(mapStateToProps)(DataExplorerParametersForm);



// WEBPACK FOOTER //
// ./src/components/core/data_explorer/DataExplorerParametersForm.js